<template>
  <div class="writer-box writer-bg">
    <HeadNavWriter ref="headeNvWriterRef"/>

    <div class="writer-box-content">

      <!-- steps -->
      <StepsWriter :active="2"/>

      <!-- elements -->
      <div class="hidden-xs-only" style="font-weight: 600; font-size: 20px; color: #000000; line-height: 24px;margin: 1rem 0;">
        故事大纲
      </div>
      <div class="writer-box-content-editor">
        <!--
          @cut.native="changeInput"
          @paste.native="changeInput" -->
        <el-input
          @input="changeInput"
          v-if="!isSkeleton" :disabled="!storyOutlineSimple&&!story.storyOutlineSimpleId" class="writer-box-input global-box-scrollbar" id="msgbox" type="textarea" v-model="storyOutlineSimple" show-word-limit></el-input>
        <LlmSkeleton v-else />
      </div>

    </div>

    <!-- footer -->
    <div class="writer-box-footer" :class="{'button-flex-between': story.articleGenType != 'GEN_BY_OUTLINE'}">
      <span v-show="story.articleGenType != 'GEN_BY_OUTLINE' && storyOutlineSimples.length==0"></span>
      <span v-show="story.articleGenType != 'GEN_BY_OUTLINE' && storyOutlineSimples.length>0">
        <!-- <el-checkbox style="margin-right: .5rem;" v-model="checked4ElementVersion" @change="changeElementVersion"></el-checkbox> -->
        <el-select class="custom-select"
            v-model="story.storyOutlineSimpleId"
            filterable
            size="mini"
            :disabled="isLoading"
            placeholder="版本">
          <el-option
            v-for="itemVersion in storyOutlineSimples"
            @click.native.stop="contentChange(itemVersion)"
            :key="itemVersion.id"
            :label="'版本 ' + itemVersion.version"
            :value="itemVersion.id"
          />
        </el-select>
      </span>
      <span class="button-group">
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" round @click="genStoryOutlineSimple()" :loading="isLoading" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyOutlineSimples.length==0">{{$i18n.locale === 'zh' ? '生成大纲' : 'Generate Outline'}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="default" round icon="el-icon-refresh" @click="handleSave(1)" :loading="isLoading" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyOutlineSimples.length>0">{{$i18n.locale === 'zh' ? '重新生成' : 'Regenerate'}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" @click="handleSave(2)" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyOutlineSimples.length>0">{{$i18n.locale === 'zh' ? '生成章纲' : 'Generate Chapter'}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" @click="handleSave(0)" :disabled="isLoading" v-if="story.articleGenType == 'GEN_BY_OUTLINE' && storyOutlineSimples.length>0">{{$i18n.locale === 'zh' ? '下一步' : 'Next'}}</el-button>
      </span>
    </div>
    <StoryIdeaDialog :enums="enums" channel="genbyzhihu_regenoutlinesimple" />
  </div>
</template>
<script>
import HeadNavWriter from '@/components/HeadNavWriter'
import StepsWriter from '@/components/StepsWriterZhihu'
import LlmSkeleton from '@/components/LlmSkeleton'
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import * as StoryOutlineSimpleApi from '@/api/storyoutlinesimple'
import { mapState, mapMutations} from 'vuex'
import StoryIdeaDialog from '@/components/StoryIdeaDialog'
import * as StoryTemplateQuestionApi from '@/api/storytemplatequestion'
import sse from '@/utils/llmstream'
export default {
  name: 'Article',
  components: {
    LlmSkeleton, HeadNavWriter, StepsWriter, StoryIdeaDialog
  },
  data() {
    return {
      checked4ElementVersion: false,
      enums: {},
      isLoading: false,
      isSkeleton: false,
    	autoRunedFlag: false,
      storyOutlineSimple: '',
      // storyOutlineSimples: [{id: '0', content: '', version: 1}],
      storyOutlineSimples: [],
      storyOutlineSimpleTemplate: ``
    }
  },
  computed: {
  	...mapState(['user', 'story', 'dialogShowCostomContactFlag'])
  },
  mounted() {

    // console.log('story', this.story)
    this.handleEnum()
    this.handlePageStoryOutlineSimpleVersion()
  },
  methods: {
    ...mapMutations(['setStory', 'setShowDialogFlag', 'setDialogShowCostomContactFlag']),
    contentChange(item){
      // console.log('contentChange', item.content);
      this.storyOutlineSimple = item.content
      this.story.storyOutlineSimple = item.content
      this.story.storyOutlineSimpleId = item.id
      this.setStory(this.story)
      this.handleUpdateStory(item)
    },
    changeInput(event){
      // console.log('changeInput', event);
      this.handleUpdateElement()
    },
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    handleUpdateStory(item) {
      ArticleApi.update({id: this.story.id,
          storyOutlineSimpleId: item.id,
          storyOutlineSimple: item.content}
      ).then(res => {

      });
    },
    handleUpdateElement() {
      if(this.isLoading){// 正在生成内容
        return false;
      }
      if(!this.story.storyOutlineSimpleId || this.story.storyOutlineSimpleId == 0){
        return false
      }
      this.story.storyOutlineSimple = this.storyOutlineSimple
      this.setStory(this.story)
      StoryOutlineSimpleApi.update({id: this.story.storyOutlineSimpleId,
          content: this.storyOutlineSimple}
      ).then(res => {
        // 更新this.storyElements = [];
        this.storyOutlineSimples.forEach((item,index)=>{
          if(this.story.storyOutlineSimpleId == item.id){
            item.content = this.storyOutlineSimple
          }
        })
      });
    },
    handlePageStoryOutlineSimpleVersion(flag){
      StoryOutlineSimpleApi.page({storyId: this.story.id, size: 100}).then(res => {
        let result = res.data.data;
        if(res.data.code == 0){
          if(result.records.length > 0){
            this.storyOutlineSimples = result.records;
            let currentElement = this.storyOutlineSimples.filter(i=>{return i.id==this.story.storyOutlineSimpleId})[0];
            if(currentElement){
              this.storyOutlineSimple = currentElement.content
              this.story.storyOutlineSimpleId = currentElement.id
            }else{
              this.story.storyOutlineSimpleId = this.storyOutlineSimples[result.records.length-1].id
              this.storyOutlineSimple = this.storyOutlineSimples[result.records.length-1].content
            }
          }else{
            this.storyOutlineSimples = [];
          }
          if ((!this.storyOutlineSimple || !this.storyOutlineSimple.trim()) && this.story.articleGenType == 'GEN_BY_OUTLINE' ) {
              this.storyOutlineSimple = this.storyOutlineSimpleTemplate;
          }
          this.story.storyOutlineSimple = this.storyOutlineSimple
          this.setStory(this.story)
          console.log('handlePageStoryOutlineSimpleVersion', this.story);
          if(result.records.length == 0){// 从创意开始，自动生成粗钢
            if(this.user.desktopFlag && !this.autoRunedFlag){
              this.autoRunedFlag = true
              this.genStoryOutlineSimple()
            }
          }
          if(flag && flag == 3 && result.records.length>0){// 自动生成标题
            this.contentChange(this.storyOutlineSimples[this.storyOutlineSimples.length-1])
          }
        }
      })
    },
    handleEnum() {
      EnumApi.list().then(res => {
        let result = res.data.data;
        this.enums = result
      })
    },
    handleSave(flag) {
      if(flag == 0){//by outline 下一步
        if (!this.storyOutlineSimple || !this.storyOutlineSimple.trim() || this.storyOutlineSimple == this.storyOutlineSimpleTemplate) {
            this.$message.error('请输入故事粗钢');
            return false;
        }
        if(this.story.stepNumber<3){
          this.story.stepNumber = 3
          this.setStory(this.story)
        }
        StoryOutlineSimpleApi.create({storyId: this.story.id, content: this.storyOutlineSimple}).then(res => {
            this.story.storyOutlineSimple = this.storyOutlineSimple
            console.log('handleSave')
            this.$router.push('/workspace/gen3');
        })
      }else if(flag == 1){// by idea : 重新生成 弹窗
        this.genStoryOutlineSimple()
      }else if(flag == 2){// by idea : 下一步
        if (!this.storyOutlineSimple || !this.storyOutlineSimple.trim() || this.storyOutlineSimple == this.storyOutlineSimpleTemplate) {
            this.$message.error('请输入故事粗钢');
            return false;
        }
        console.log('handleSave flag=2 this.story.stepNumber', this.story.stepNumber)
        if(this.story.stepNumber<3){
          this.story.stepNumber = 3
          this.setStory(this.story)
        }
        setTimeout(()=>{
          this.$router.push('/workspace/gen3');
        },300)
      }else if(flag == 3){//by idea AI 生成完之后保存版本
        if(this.story.stepNumber<3){
          this.story.stepNumber = 3
          this.setStory(this.story)
        }
        this.handlePageStoryOutlineSimpleVersion(3)
      }
    },
    handleBlur() {
      // this.handleSave();
    },
    scrollToBottom() {
      const msgbox = document.getElementById("msgbox")
      msgbox.scrollTop = msgbox.scrollHeight;
    },
    handleStoryOutlineSimpleMsg(msg){
      this.isSkeleton = false;
      this.storyOutlineSimple = msg
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    handleGenerationFailure(error) {
      console.error(error)
      const partialOutput = error && typeof error.partialOutput === 'string'
        ? error.partialOutput
        : ''
      if (partialOutput.trim()) {
        this.storyOutlineSimple = partialOutput
        this.story.storyOutlineSimple = partialOutput
        this.setStory(this.story)
        this.$message.warning('生成未正常结束，已保留当前草稿；请勿刷新，可复制后再重试')
      } else {
        const currentElement = this.storyOutlineSimples.find(
          item => item.id == this.story.storyOutlineSimpleId
        )
        if (currentElement) {
          this.storyOutlineSimple = currentElement.content
        }
      }
      this.isLoading = false
      this.isSkeleton = false
    },
    genStoryOutlineSimple() {
        console.log('story::element', this.story);
        this.isLoading = true;
        this.isSkeleton = true;
        this.storyOutlineSimple = ''
        let params = Object.assign({}, this.story)
        params.articleId = this.story.id
        params.content = this.story.storyIdea
        params.platformCategory = 'WRITER_WEB'

// 1816677726778699778 old

        // 自由模式
        let workflowId = "1828719933174030338"
        // 模板模式
        if(this.story.storyTemplateId && this.story.storyTemplateId != '0'){
          workflowId = "1828803160358187010";
          // 获取当前用户的QA列表（故事大纲)
          let templateId = this.story.storyTemplateId
          StoryTemplateQuestionApi.page({templateId, storyId:this.story.id, accountId:this.user.id,size: 20}).then(res => {
            let result = res.data.data;
            let storyTemplateQuestions = result.records

            let history = []
            storyTemplateQuestions.forEach((item,index) => {
              if(item.answerVo && item.answerVo.answer){
                history.push('Q'+(index+1)+':'+item.title)
                history.push('A'+(index+1)+':'+item.answerVo.answer)
              }else{
                history.push('Q'+(index+1)+':'+item.title)
                history.push('A'+(index+1)+':')
              }
            })
            console.log('findQaHistory ', history);
            params.storyQaHistory = history.join('\n')

            sse(workflowId, params, this.handleStoryOutlineSimpleMsg).then((result)=>{
              // console.log('result', result);
              //AI结束，处理逻辑
              this.isLoading = false;
              this.isSkeleton = false;
              this.storyOutlineSimple = result
              this.story.storyOutlineSimple = result
              this.setStory(this.story)
              // 保存版本
              this.handleSave(3)
              this.$refs.headeNvWriterRef.syncUser()
            }).catch(this.handleGenerationFailure)
          });
        }else{
          sse(workflowId, params, this.handleStoryOutlineSimpleMsg).then((result)=>{
            // console.log('result', result);
            //AI结束，处理逻辑
            this.isLoading = false;
            this.isSkeleton = false;
            this.storyOutlineSimple = result
            this.story.storyOutlineSimple = result
            this.setStory(this.story)
            // 保存版本
            this.handleSave(3)
            this.$refs.headeNvWriterRef.syncUser()
          }).catch(this.handleGenerationFailure)
        }
    }
  }
}
</script>
<style scoped lang="scss">

</style>
